module.exports = __webpack_public_path__ + "img/pulse.df3aba66.png";